import React, { useState, useCallback } from "react";
import { Text } from "@salestrak/ui";
import type { ActivityChange } from "../activity-types";
import { useOptionalActivityContext } from "../activity-context";

interface NoteReplyChunkProps {
  change: ActivityChange;
}

export function NoteReplyChunk({ change }: NoteReplyChunkProps) {
  const ctx = useOptionalActivityContext();
  const [isLoading, setIsLoading] = useState(false);

  const handleViewReply = useCallback(async () => {
    if (!change.noteReply) return;
    const parentNoteId = Object.keys(change.noteReply)[0];
    if (!parentNoteId || !ctx?.scrollToNote) return;
    const targetNoteId = change.noteReply[parentNoteId]?.after;
    if (!targetNoteId) return;

    setIsLoading(true);
    try {
      await ctx.scrollToNote(targetNoteId, parentNoteId);
    } finally {
      setIsLoading(false);
    }
  }, [change.noteReply, ctx]);

  return (
    <Text size="sm">
      {change.action} a {change.subject}{" "}
      {/* Inline pressable Text (a span) — never a Button, which is a flex box
          and would break out of this sentence onto its own line. */}
      <Text
        size="sm"
        variant="primary"
        className="cursor-pointer select-none"
        onClick={isLoading ? undefined : handleViewReply}
      >
        View reply
      </Text>
    </Text>
  );
}
